import { __assign, __rest, __spreadArray } from "tslib";
import * as React from 'react';
function validateNewOptionDefault(searchValue, newOption, value, options) {
    if (!searchValue) {
        return null;
    }
    function hasOption(_a) {
        var label = _a.label, value = _a.value;
        return label === newOption.label || value === newOption.value;
    }
    // Verify option doesn't exist in selected options
    if (value === null || value === void 0 ? void 0 : value.some(hasOption)) {
        return null;
    }
    if (options === null || options === void 0 ? void 0 : options.some(function (option) {
        return 'options' in option ? option.options.some(hasOption) : hasOption(option);
    })) {
        return null;
    }
    return newOption;
}
function createOption(searchValue) {
    return {
        value: "created-".concat(searchValue),
        label: searchValue,
        __isNew__: true,
    };
}
export function useCreatable(props) {
    var _a;
    var strings = props.strings, _b = props.options, optionsProp = _b === void 0 ? [] : _b, onSearch = props.onSearch, onChange = props.onChange, onCreateOption = props.onCreateOption, _c = props.validateNewOption, validateNewOption = _c === void 0 ? validateNewOptionDefault : _c, controlledValue = props.value, defaultValue = props.defaultValue, comboboxProps = __rest(props, ["strings", "options", "onSearch", "onChange", "onCreateOption", "validateNewOption", "value", "defaultValue"]);
    var isMulti = comboboxProps.isMulti;
    var createOptionLabel = strings.createOptionLabel, comboboxStrings = __rest(strings, ["createOptionLabel"]);
    var initialValue = (_a = controlledValue !== null && controlledValue !== void 0 ? controlledValue : defaultValue) !== null && _a !== void 0 ? _a : [];
    var formatValue = React.useCallback(function (value) { return (Array.isArray(value) ? value : [value]); }, []);
    var _d = React.useState(formatValue(initialValue)), selectedOptions = _d[0], setSelectedOptions = _d[1];
    var _e = React.useState(''), searchValue = _e[0], setSearchValue = _e[1];
    var newOption = React.useMemo(function () {
        return validateNewOption(searchValue, createOption(searchValue), selectedOptions, optionsProp);
    }, [searchValue, selectedOptions, optionsProp, validateNewOption]);
    var createdOptions = React.useMemo(function () { var _a; return (_a = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.filter(function (_a) {
        var __isNew__ = _a.__isNew__;
        return __isNew__;
    })) !== null && _a !== void 0 ? _a : []; }, [selectedOptions]);
    var options = React.useMemo(function () {
        return newOption
            ? __spreadArray(__spreadArray(__spreadArray([], createdOptions, true), optionsProp, true), [newOption], false) : __spreadArray(__spreadArray([], createdOptions, true), optionsProp, true);
    }, [newOption, optionsProp, createdOptions]);
    var handleOnSearch = React.useCallback(function (searchString) {
        setSearchValue(searchString);
        if (onSearch) {
            onSearch(searchString);
        }
    }, [onSearch]);
    var handleOnChange = React.useCallback(function (value, data) {
        var isCreatedOption = data.option && '__isNew__' in data.option;
        var valueArray = formatValue(value);
        if (onCreateOption && isCreatedOption) {
            onCreateOption(data.option.label);
        }
        else {
            setSelectedOptions(valueArray);
            if (onChange) {
                var action = data.action === 'select-option' && isCreatedOption ? 'create-value' : data.action;
                if (isMulti) {
                    var onChangeMulti = onChange;
                    onChangeMulti(valueArray, __assign(__assign({}, data), { action: action }));
                }
                else {
                    var onChangeSingle = onChange;
                    onChangeSingle(valueArray[0], __assign(__assign({}, data), { action: action }));
                }
            }
        }
    }, [onChange, onCreateOption, isMulti, formatValue]);
    return __assign({ options: options, strings: comboboxStrings, onChange: handleOnChange, onSearch: handleOnSearch, value: selectedOptions, defaultValue: defaultValue }, comboboxProps);
}
export default useCreatable;
//# sourceMappingURL=useCreatable.js.map